import React, { useEffect, useState } from 'react';
import '../../App.css';
import WrappedPage from './Wrapped.js'
import { useNavigate, useParams, Navigate } from 'react-router-dom'

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN;

const ProfilePage = ({handlePageChange}) => {
  const [activeTab, setActiveTab] = useState('games');
  const [userProfile, setUserProfile] = useState({});
  const [loading, setLoading] = useState(true);
  const [errorFetch, setErrorFetch] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("user"));
  let ownProfile = false;
  if (id == user.uuid) ownProfile = true;
  useEffect(() => {
    async function getProfile() {
      try {
        const res = await fetch(`${BACKEND_ORIGIN}/profile`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userID: id,
            ownProfile: ownProfile
          }),
          credentials: "include"
        });
        if (!res.ok) {
          alert(`Fetch error (not ok): ${res.message}`)
          throw new Error(`Fetch error (not ok): ${res.message}`)
        }
        const jsonData = await res.json();
        setUserProfile(jsonData);
        setErrorFetch(false);
      }
      catch (e) {
        alert("Fetch error: " + e);
        setErrorFetch(true);
      }
      finally {
        setLoading(false);
      }
    }
    getProfile();
  }, []);
  if (loading) {
    return <div>Loading profile...</div>
  }
  if (errorFetch) {
    return <div>Error fetching profile!</div>
  }
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  if (!id) {
    return <Navigate to={`/app/profile/${user.uuid}`} replace />
  }
  const gamesWatched = [];
  const reviews = [];
  for (let i = 0; i < userProfile.reviews.length; i++) {
    gamesWatched.push(
      <div className="game-watched-item" key={i}>
        <div className="watched-score-tag">{userProfile.reviews[i].away} {userProfile.reviews[i].awayScore} · {userProfile.reviews[i].homeScore} {userProfile.reviews[i].home}</div>
        <div className="watched-game-info">
          <div className="watched-game-title">{userProfile.reviews[i].awayLong} vs {userProfile.reviews[i].homeLong}</div>
          <div className="watched-game-date">NCAA College Football · {userProfile.reviews[i].gameDate.split("T")[0]}</div>
        </div>
{/* TODO: Figure out if reviews should show here (specifically stars and publicity if that game has a review for it) */}
        
        <div className="watched-stars">
          <span className={`star ${userProfile.reviews[i].stars >= 1 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 2 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 3 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 4 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 5 ? "" : "empty"}`}>★</span>
        </div>
        <div className={`visibility-badge ${userProfile.reviews[i].public == 0 ? "friends" : "public" }`} style={{fontSize: '9px'}}>{`${userProfile.reviews[i].public == 0 ? "Friends" : "Public" }`}</div>
      </div>
    );
    if (id != user.uuid && userProfile.reviews[i].public == 0) {
      continue;
    }
    reviews.push(
      <div className="game-watched-item" key={i}>
        <div className="watched-score-tag">{userProfile.reviews[i].away} {userProfile.reviews[i].awayScore} · {userProfile.reviews[i].homeScore} {userProfile.reviews[i].home}</div>
        <div className="watched-game-info">
          <div className="watched-game-title">{userProfile.reviews[i].awayLong} vs {userProfile.reviews[i].homeLong}</div>
          <div className="watched-game-date">NCAA College Football · {userProfile.reviews[i].gameDate.split("T")[0]}</div>
          <div className="watched-game-date">{userProfile.reviews[i].review}</div>
        </div>
{/* TODO: Figure out if reviews should show here (specifically stars and publicity if that game has a review for it) */}
        
        <div className="watched-stars">
          <span className={`star ${userProfile.reviews[i].stars >= 1 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 2 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 3 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 4 ? "" : "empty"}`}>★</span>
          <span className={`star ${userProfile.reviews[i].stars >= 5 ? "" : "empty"}`}>★</span>
        </div>
        <div className={`visibility-badge ${userProfile.reviews[i].public == 0 ? "friends" : "public" }`} style={{fontSize: '9px'}}>{`${userProfile.reviews[i].public == 0 ? "Friends" : "Public" }`}</div>
      </div>
    );
  }
  if (id == user.uuid) {
    return (
      <div id="page-profile" className="page-active">
        <div className="profile-hero"></div>
        <div className="profile-content">
          <div className="profile-avatar-wrap">
            <div className="profile-avatar verified">USER</div>
          </div>
          <div className="profile-name">{user.firstName + " " + user.lastName}</div>
          <div className="profile-handle">@{user.userName}</div>
          <div className="profile-bio">{userProfile.user.biography}</div>

          <div className="profile-stats">
            <div className="profile-stat">
              <div className="num">{userProfile.friends.length}</div>
              <div className="label">Friends</div>
            </div>{/*
            <div className="profile-stat">
              <div className="num">1.2K</div>
              <div className="label">Fans</div>
            </div>*/}
            <div className="profile-stat">
              <div className="num">{userProfile.gamesWatched}</div>
              <div className="label">Games Watched</div>
            </div>
            <div className="profile-stat">
              <div className="num">{(userProfile.reviewAvg != "N/A") ? Number(userProfile.reviewAvg).toFixed(1) : "N/A"}★</div>
              <div className="label">Avg Rating</div>
            </div>
          </div>

          <div className="profile-actions">
            <button className="btn-primary">Edit Profile</button>
            <button className="btn-secondary">
              <i className="ti ti-share" aria-hidden="true"></i> Share
            </button>
          </div>

          <div className="profile-tabs">
            <div
              className={`profile-tab ${activeTab === 'games' ? 'active' : ''}`}
              onClick={() => handleTabChange('games')}
            >
              Games Watched
            </div>
            <div
              className={`profile-tab ${activeTab === 'reviews' ? 'active' : ''}`}
              onClick={() => handleTabChange('reviews')}
            >
              Reviews
            </div>
            <div
              className={`profile-tab ${activeTab === 'friends' ? 'active' : ''}`}
              onClick={() => handleTabChange('friends')}
            >
              Friends
            </div>
            <div
              className={`profile-tab ${activeTab === 'fans' ? 'active' : ''}`}
              onClick={() => handleTabChange('fans')}
            >
              Fans
            </div>
            <div
              className="profile-tab"
              onClick={() => navigate('/app/wrapped')}
            >
              🎁 Wrapped
            </div>
          </div>

          {activeTab === 'games' && (
            <div className="games-watched-list">
              {gamesWatched}
            </div>
          )}
          {activeTab === 'reviews' && (
            <div className="games-watched-list">
              {reviews}
            </div>
          )}
        </div>
      </div>
    );
  }
  return (
    <div id="page-profile" className="page-active">
      <div className="profile-hero"></div>
      <div className="profile-content">
        <div className="profile-avatar-wrap">
          <div className="profile-avatar verified">USER</div>
        </div>
        <div className="profile-name">{userProfile.user.firstname + " " + userProfile.user.lastname}</div>
        <div className="profile-handle">@{userProfile.user.username}</div>
        <div className="profile-bio">{userProfile.user.biography}</div>

        <div className="profile-stats">
          <div className="profile-stat">
            <div className="num">{userProfile.friends.length}</div>
            <div className="label">Friends</div>
          </div>{/*
          <div className="profile-stat">
            <div className="num">1.2K</div>
            <div className="label">Fans</div>
          </div>*/}
          <div className="profile-stat">
            <div className="num">{userProfile.gamesWatched}</div>
            <div className="label">Games Watched</div>
          </div>
          <div className="profile-stat">
            <div className="num">{(userProfile.reviewAvg != "N/A") ? Number(userProfile.reviewAvg).toFixed(1) : "N/A"}★</div>
            <div className="label">Avg Rating</div>
          </div>
        </div>

        <div className="profile-actions">
          <button className="btn-primary">+ Add Friend</button>
          <button className="btn-secondary">
            <i className="ti ti-user-plus" aria-hidden="true"></i> Follow as Fan
          </button>
          <button className="btn-secondary">
            <i className="ti ti-share" aria-hidden="true"></i> Share
          </button>
        </div>

        <div className="profile-tabs">
          <div
            className={`profile-tab ${activeTab === 'games' ? 'active' : ''}`}
            onClick={() => handleTabChange('games')}
          >
            Games Watched
          </div>
          <div
            className={`profile-tab ${activeTab === 'reviews' ? 'active' : ''}`}
            onClick={() => handleTabChange('reviews')}
          >
            Reviews
          </div>
          <div
            className={`profile-tab ${activeTab === 'friends' ? 'active' : ''}`}
            onClick={() => handleTabChange('friends')}
          >
            Friends
          </div>
          <div
            className={`profile-tab ${activeTab === 'fans' ? 'active' : ''}`}
            onClick={() => handleTabChange('fans')}
          >
            Fans
          </div>
          <div
            className="profile-tab"
            onClick={() => navigate('/app/wrapped')}
          >
            🎁 Wrapped
          </div>
        </div>

        {activeTab === 'games' && (
          <div className="games-watched-list">
            {gamesWatched}
          </div>
        )}
        {activeTab === 'reviews' && (
          <div className="games-watched-list">
            {reviews}
          </div>
        )}
      </div>
    </div>
  );
};

export default ProfilePage;
